import { Component } from 'preact';
import style from './style.scss';

class LoadingScreen extends Component {

	constructor(props) {
		super(props);

		this.state = {
			isVisible: false
		};
	}

	componentDidMount() {
		// Don't show the loader if content loads immediately. Only show if it takes longer than approx. 0.3s.
		setTimeout(() => this.setState({ isVisible: true }), 300);
	}

	render() {
		if (!this.state.isVisible) {
			return null;
		}

		return (
			<div class={style.loading_screen}>
				<div>Loading</div>
			</div>
		);
	}

}

export default LoadingScreen;



// WEBPACK FOOTER //
// ./components/loading-screen/index.js